import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SERVER_API_URL } from 'src/app/app.constants';

@Injectable({
  providedIn: 'root'
})
export class AwardsService {

  AWARD_API_BASE_URL= SERVER_API_URL+'awards/';

  constructor(private http: HttpClient) { }

  getAwardsHome(regionCodes: string[]): Observable<any> {
    let options: HttpParams = new HttpParams();
    for (let regionCode of regionCodes) {
      options=options.append('regionCode',regionCode);
    }
    return this.http.get<any>(this.AWARD_API_BASE_URL + 'home', { params: options});
  }

  getAwardsByBand(regionCodes: string[], bandCode: string) : Observable<any> {
    let options: HttpParams = new HttpParams();
    for (let regionCode of regionCodes) {
      options=options.append('regionCode',regionCode);
    }
    return this.http.get<any>(this.AWARD_API_BASE_URL+'band/'+bandCode, { params: options});
  }

  getAwardsByBandGroup(regionCodes: string[], bandGroup: string) : Observable<any> {
    let options: HttpParams = new HttpParams();
    for (let regionCode of regionCodes) {
      options=options.append('regionCode',regionCode);
    }
    return this.http.get<any>(this.AWARD_API_BASE_URL+'bandGroup/'+bandGroup, { params: options});
  }

  getAwardsByCountry(countryCode: string) : Observable<any> {
    return this.http.get<any>(this.AWARD_API_BASE_URL+'country/'+countryCode);
  }

  getAwardsByCountryBand(countryCode: string, bandCode: string) : Observable<any> {
    return this.http.get<any>(this.AWARD_API_BASE_URL+'country/'+countryCode+'/band/'+bandCode);
  }

  getAwardsByCountryBandGroup(countryCode: string, bandGroup: string) : Observable<any> {
    return this.http.get<any>(this.AWARD_API_BASE_URL+'country/'+countryCode+'/bandGroup/'+bandGroup);
  }

  getAwardsByKey(awardKey: string) : Observable<any> {
    return this.http.get<any>(this.AWARD_API_BASE_URL+'key/'+awardKey);
  }
}
